import {
  PrinterOutlined,
  DownloadOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import { get_manual_journal } from "../../../../../Controllers/Accounting/Services/manualJournalsService";
import moment from "moment";
import Loadercomponent from "../../../../../Componets/Loader";
import toast from "react-hot-toast";
import URL from "../../../../../Main/url";
import { Button, Tooltip } from "antd";

const JournalEntryView = () => {
  const componentRef = useRef();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [companyName, setCompanyName] = useState("For Company");
  const [journalEntry, setJournalEntry] = useState(null);

  const fetchData = async () => {
    setLoader(true);
    try {
      const data = await get_manual_journal(id);
      if (data?.status) {
        setJournalEntry(data);
        setCompanyName(data?.branch?.name || "Company");
      } else {
        toast.error(data?.message || "Failed to fetch journal entry");
      }
    } catch (error) {
      toast.error("Error fetching journal entry");
    }
    setLoader(false);
  };

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      .a4-journal-container {
        @page {
          size: A4;
          margin: 4% 4% 12% 4%;
        }

        .a4-journal-footer {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
        
        .a4-journal-footer-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    fetchData();
    injectScopedStyles();
  }, [id]);

  const formatAmount = (amount) => parseFloat(amount || 0).toFixed(3);

  const handleOpenInNewTab = (file) => {
    const fileUrl = `${URL}${file.url}`;
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="p-4">
      <Loadercomponent loader={loader}>
        <div className="flex justify-center">
          <div className="w-[8.27in] text-right py-4">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="bg-white border rounded hover:border-green-500"
                  type="button"
                  size="large"
                >
                  A4 Print <PrinterOutlined className="text-lg" />
                </Button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>

        <div
          className="flex justify-center a4-journal-container"
          ref={componentRef}
        >
          <div>
            <div className="text-medium text-xl text-center">Journal Entry</div>

            <div className="text-xs pb-6">
              <div className="flex justify-between">
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td className="font-semibold text-sm">
                          Journal Entry Details
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Description: {journalEntry?.description || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Status: {journalEntry?.status?.toUpperCase() || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Contra Entry:{" "}
                          {journalEntry?.contraEntry?.isContra ? "Yes" : "No"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td>Journal Entry No</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {journalEntry?.entryId || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>Reference Number</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {journalEntry?.referenceNumber || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {moment(journalEntry?.date).format("DD-MM-YYYY")}
                        </td>
                      </tr>
                      <tr>
                        <td>Created At</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {moment(journalEntry?.createdAt).format(
                            "DD-MM-YYYY HH:mm"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Internal Ref</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {journalEntry?.ref || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div>
              <table className="w-full">
                <thead className="bg-black">
                  <tr className="text-sm">
                    <th className="font-normal text-white text-left py-2 pl-3">
                      S.No
                    </th>
                    <th className="font-normal text-white text-left p-2">
                      Account Code
                    </th>
                    <th className="font-normal text-white text-left p-2">
                      Account Name
                    </th>
                    <th className="font-normal text-white text-center p-2">
                      Type
                    </th>
                    <th className="font-normal text-white text-center p-2">
                      Reference
                    </th>
                    <th className="font-normal text-white text-center p-2">
                      Description
                    </th>
                    <th className="font-normal text-white text-right pr-2">
                      Debit (OMR)
                    </th>
                    <th className="font-normal text-white text-right pr-2">
                      Credit (OMR)
                    </th>
                  </tr>
                </thead>

                <tbody className="text-sm">
                  {journalEntry?.entries?.map((entry, index) => (
                    <tr key={entry._id} className="border-b border-gray-300">
                      <td className="p-1 text-center">{index + 1}</td>
                      <td className="p-1 text-left">{entry.account?.code}</td>
                      <td className="p-1 text-left">{entry.account?.name}</td>
                      <td className="p-1 text-center uppercase">
                        {entry.type}
                      </td>
                      <td className="p-1 text-center">{entry.reference}</td>
                      <td className="p-1 text-center">
                        {entry.description || "N/A"}
                      </td>
                      <td className="p-1 text-right pr-2">
                        {entry.type === "debit"
                          ? formatAmount(entry.amount)
                          : "0.000"}
                      </td>
                      <td className="p-1 text-right pr-2">
                        {entry.type === "credit"
                          ? formatAmount(entry.amount)
                          : "0.000"}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tbody className="text-sm">
                  <tr className="border-t-2 border-black">
                    <th colSpan={6} className="font-normal text-right p-2">
                      Total
                    </th>
                    <th className="font-normal text-right text-white bg-black p-2">
                      {formatAmount(journalEntry?.totalDebits)}
                    </th>
                    <th className="font-normal text-right text-white bg-black p-2">
                      {formatAmount(journalEntry?.totalCredits)}
                    </th>
                  </tr>
                  <tr>
                    <td colSpan={6} className="text-right p-1 font-semibold">
                      Difference
                    </td>
                    <td colSpan={2} className="text-center p-1 font-semibold">
                      {formatAmount(
                        (journalEntry?.totalDebits || 0) -
                          (journalEntry?.totalCredits || 0)
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {journalEntry?.documents?.length > 0 && (
              <div className="mt-8 text-xs">
                <div className="mb-2 font-semibold">Attachments:</div>
                <ul className="space-y-2">
                  {journalEntry.documents.map((file, idx) => (
                    <li
                      key={file._id}
                      className="flex items-center justify-between border p-2 rounded"
                    >
                      <div className="flex items-center gap-2">
                        <FilePdfOutlined className="text-red-500" />
                        <span>
                          {idx + 1}. {file.name} (
                          {(file.size / 1024).toFixed(1)} KB)
                        </span>
                      </div>
                      <Tooltip title="Open in new tab">
                        <Button
                          icon={<DownloadOutlined />}
                          type="primary"
                          size="small"
                          onClick={() => handleOpenInNewTab(file)}
                        >
                          Open
                        </Button>
                      </Tooltip>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </Loadercomponent>
    </div>
  );
};

export default JournalEntryView;
